import aes from '../../utils/aes'
import {Toast, isnull} from '../../utils/tools'
import devext, {log} from '../../utils/devext'
import Tips from '../../utils/Tips'

const CustomMessageType = {
  SysRoomHint: 1, // 房间提示

  SysJoinLoom: 2, // 加入房间

  SysTextMessage: 3, // 弹幕消息

  SysSendGift: 4, // 礼物消息
  SysIsMute: 5, // 禁言
  SysCanleMute: 6, // 取消禁言

  SysRoomMessage: 7, // 房间信息 做房间页面刷新

  SysTAKEANCHOR: 8, // 带走主播

  /**
   * pk匹配成功
   *
   * content = VideoChatRoomPkMatchSuccessedMsgBean   json
   */
  SysPkMatchSuccess: 9,
  /**
   * pk结束
   */
  SysPkEnd: 10,
  /**
   * pk分数更新
   *
   * content = VideoChatRoomPkPointUpdatedMsgBean     json
   */
  SysPkPointUpdate: 11,
  /**
   * pk倒计时结束
   */
  SysPkTimeUp: 12,
  /**
   * pk准备好下一局
   *
   * content = 准备方的accountId
   */
  SysPkOnceMore: 13,
  /**
   * pk中对方逃跑
   */
  SysPkRunAway: 14,
  /**
   * pk私聊开关改变
   * content = {"roomId":1,"privateChatFlag":1}
   * 1:开启
   * 2:关闭
   */
  SysPkPrivateFlagChange: 15,
  /**
   * 直播间更新房间观众列表
   */
  SysUpdateRoomMember: 16,
  /**
   * 点对点消息，pk中通知对方房主自己这边已经关闭视频
   * content = "0" / "1"
   */
  SysPeerMsgVideoMuteChange: 17,

  /**
   * 转盘消息
   * @return
   */
  SYSTURNTABLE: 18
}

const ChannelAttrKey = {
  ATTR_KEY_MUTE_PK_AUDIO: 'muteOpAudio',
  ATTR_VALUE_MUTE: 'true',
  ATTR_VALUE_UNMUTE: 'false',
  ATTR_KEY_MUTE_PK_VIDEO: 'muteOpVideo'
}


// 是否被禁言文字消息
var hasBeenMute = false

export function login (pageObj) {
  if (!pageObj.rtm)
    return
  try {
    pageObj.rtm.init(aes.decrypt(pageObj.$globalAppCfg.agoapp))
    pageObj.rtm.login(pageObj.$globalAppCfg.user.displayAccountId, '').then(() => {
      console.log('login')
      pageObj.rtm._logined = true
      Toast.notice('Login: ' + pageObj.$globalAppCfg.user.accountId, ' token: ', '')
    }).catch((err) => {
      console.log(err)
    })
  } catch (err) {
    Toast.error('Login failed, please open console see more details')
    console.error(err)
  }
}

export function loginOut (pageObj) {
  if (!pageObj.rtm||!pageObj.rtm._logined) {
    return
  }
  pageObj.rtm.logout().then(() => {
    console.log('logout')
    pageObj.rtm._logined = false
    Toast.notice('Logout: ' + pageObj.rtm.accountName)
    pageObj.$globalAppCfg.agoChatClient = null
  }).catch((err) => {
    Toast.error('Logout failed, please open console see more details')
    console.log(err)
  })
}

export function joinChannel (channel, pageObj) {
  if (isnull(channel)) {
    Toast.error('Channel is empty',pageObj)
    return
  }
  if (!pageObj.rtm._logined) {
    Toast.error('Please Login First',pageObj)
    login(pageObj)
    return
  }
  if (pageObj.rtm.channels[channel] ||
    (pageObj.rtm.channels[channel] && pageObj.rtm.channels[channel].joined)) {
    Toast.error('You already joined',pageObj,pageObj)
    return
  }
  pageObj.rtm.joinChannel(channel).then(() => {
    // const view = $('<div/>', {
    //   text: rtm.accountName + ' join channel success'
    // })
    // $('#log').append(view)
    Toast.error(pageObj.rtm.accountName + ' join channel success',pageObj)
    pageObj.rtm.channels[channel].joined = true
  }).catch((err) => {
    Toast.error('Join channel failed, please open console see more details.')
    console.error(err)
  })
}

export function leaveChannel (channel, pageObj) {
  if (isnull(channel)) {
    Toast.error('Channel is empty')
    login(pageObj)
    return
  }
  if (!pageObj.rtm._logined) {
    Toast.error('Please Login First')
    return
  }
  if (!pageObj.rtm.channels[channel] ||
    (pageObj.rtm.channels[channel] && !pageObj.rtm.channels[channel].joined)) {
    Toast.error('You already leave')
    return
  }
  pageObj.rtm.leaveChannel(channel).then(() => {
    Toast.error(pageObj.rtm.accountName + ' leave channel success')
    if (pageObj.rtm.channels[channel]) {
      pageObj.rtm.channels[channel].joined = false
      pageObj.rtm.channels[channel] = null
    }
  }).catch((err) => {
    Toast.error('Leave channel failed, please open console see more details.')
    console.error(err)
  })
}

export function sendChannelMsg (channel, msg, pageObj) {
  if (!pageObj.rtm._logined) {
    Toast.error('Please Login First')
    login(pageObj)
    return
  }
  if (!pageObj.rtm.channels[channel] ||
    (pageObj.rtm.channels[channel] && !pageObj.rtm.channels[channel].joined)
  ) {
    Toast.error('Please Join first')
    return
  }
  pageObj.rtm.sendChannelRawMessage(msg, channel).then(() => {
    Toast.info(pageObj.rtm.accountName + ' send : ' + msg + ' channel: ' + channel)
  }).catch((err) => {
    Toast.error('Send message to channel ' + channel + ' failed, please open console see more details.')
    console.error(err)
  })
}

export function sendPeerMsg (msg, peerId, pageObj) {
  if (pageObj.rtm._logined) {
    Toast.error('Please Login First')
    login(pageObj)
    return
  }
  if (isnull(msg) || isnull(peerId)) {
    Toast.error('Params error')
    return
  }
  pageObj.rtm.sendPeerMessage(msg, peerId).then(() => {
    Toast.info(pageObj.rtm.accountName + ' send : ' + msg + ' peerId: ' + peerId)
  }).catch((err) => {
    Toast.error('Send message to peer ' + peerId + ' failed, please open console see more details.')
    console.error(err)
  })
}

export function queryPeerStatus (memberId, pageObj) {
  if (!pageObj.rtm._logined) {
    Toast.error('Please Login First')
    login(pageObj)
    return
  }
  if (isnull(memberId)) {
    Toast.error('Params error')
    return
  }
  pageObj.rtm.queryPeersOnlineStatus(memberId).then((res) => {
    Toast.info('memberId: ' + memberId + ', online: ' + res[memberId])
  }).catch((err) => {
    Toast.error('query peer online status failed, please open console see more details.')
    console.error(err)
  })
}

export function sendMessage (type, text, giftId = 0, como = 1, isBlindBox = false, needSend = true, needRefreshLocal = true, vueObj) {

}
export function getRtmChannelInfo (channel, pageV) {
  pageV.rtm.getChannelAttrs(channel).then((channelAttributes) => {
    for (let i = 0; i < channelAttributes.length; i++) {
      let attr = channelAttributes[i]
      if (attr.key === pageV.$globalAppCfg.user.accountId.toString()) {
        hasBeenMute = isMute(attr.value)
      } else if (attr.key === ChannelAttrKey.ATTR_KEY_MUTE_PK_AUDIO) {
        // 静音pk
        log('getChannelAttrs', '获取pk中静音对方的值     value=' + attr.value)
        if (attr.value === ChannelAttrKey.ATTR_VALUE_MUTE) {
          // rtmListener?.onPkRemoteAudioMuteChange(true)
        } else {
          // rtmListener?.onPkRemoteAudioMuteChange(false)
        }
      } else if (attr.key === ChannelAttrKey.ATTR_KEY_MUTE_PK_VIDEO) {
        // pk视频关闭
      }
    }
  })
}
/**
 * 判断是否被禁言文字消息
 */
function isMute (value) {
  if (value == null) {
    return false
  }

  if (value === '1') {
    return true
  } else {
    var channelAttribute = JSON.parse(value)
    var now = new Date()
    log('时间封禁', '' + channelAttribute.muteExpire)
    log('时间当前', '' + now)
    if (channelAttribute.muteExpire > now.getTime()) {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/pages/live/chat.js